__turbopack_context__.v({
  "caroBtn": "ImageCarouselDots-module__nnEo6a__caroBtn",
  "controls": "ImageCarouselDots-module__nnEo6a__controls",
  "dot": "ImageCarouselDots-module__nnEo6a__dot",
  "dotActive": "ImageCarouselDots-module__nnEo6a__dotActive",
  "dots": "ImageCarouselDots-module__nnEo6a__dots",
  "largerDots": "ImageCarouselDots-module__nnEo6a__largerDots",
  "smallDots": "ImageCarouselDots-module__nnEo6a__smallDots",
});
